/* Doggy reviews: endless carousel that keeps sliding on its own (Boris, 2026-10-20).
   The cards are rendered 3 times (copy, real, copy). We start on the real set; whenever the view drifts into a copy
   we jump silently by one set width, so it never ends. Auto-slide pauses while the visitor touches / drags / hovers. */
(function () {
  var SPEED = 38; /* px per second */
  function setup(el) {
    if (el.__dgLoop) return; el.__dgLoop = true;
    var n = parseInt(el.getAttribute('data-loop'), 10) || 0;
    var cards = el.children; if (n < 2 || cards.length < n * 3) return;
    var rtl = getComputedStyle(el).direction === 'rtl';
    function delta() { return cards[n].getBoundingClientRect().left - cards[0].getBoundingClientRect().left; }
    function centerIndex() {
      var mid = el.getBoundingClientRect().left + el.clientWidth / 2, best = 0, bd = 1e9;
      for (var i = 0; i < cards.length; i++) { var r = cards[i].getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid); if (d < bd) { bd = d; best = i; } }
      return best;
    }
    var pos = 0, auto = false, visible = true, idle, last = 0;
    function jump(by) {
      el.style.scrollBehavior = 'auto';
      el.scrollLeft += by; pos = el.scrollLeft;
      el.style.scrollSnapType = 'none'; setTimeout(function () { el.style.scrollSnapType = ''; el.style.scrollBehavior = ''; }, 60);
    }
    function wrap() { var i = centerIndex(), d = delta(); if (i < n) jump(d); else if (i >= 2 * n) jump(-d); }
    /* auto-slide */
    function play() { if (auto || matchMedia('(prefers-reduced-motion: reduce)').matches) return; auto = true; pos = el.scrollLeft; el.classList.add('is-auto'); last = 0; requestAnimationFrame(tick); }
    function pause(resumeIn) { auto = false; el.classList.remove('is-auto'); el.style.scrollSnapType = ''; clearTimeout(idle); if (resumeIn) idle = setTimeout(play, resumeIn); }
    function step(dt) { pos += (rtl ? -1 : 1) * SPEED * dt; el.scrollLeft = Math.round(pos); if (Math.abs(el.scrollLeft - Math.round(pos)) > 2) pos = el.scrollLeft; wrap(); }
    function tick(t) { if (!auto) return; var dt = last ? Math.min((t - last) / 1000, 0.05) : 0; last = t; if (visible) step(dt); requestAnimationFrame(tick); }
    el.__dgStep = step; /* for testing */
    /* the visitor takes over: stop, let snap work, resume after a short rest */
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { el.addEventListener(ev, function () { pause(2500); }, { passive: true }); });
    el.addEventListener('mouseenter', function () { pause(0); });
    el.addEventListener('mouseleave', function () { pause(1200); });
    var t; el.addEventListener('scroll', function () { if (auto) return; clearTimeout(t); t = setTimeout(wrap, 140); }, { passive: true });
    el.addEventListener('scrollend', function () { if (!auto) { clearTimeout(t); wrap(); } });
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(wrap, 200); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(el);
    function start() { jump(delta()); play(); }
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  }
  function init() { document.querySelectorAll('.dg-rev--loop').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
